import React from "react";
import Typography from "@mui/material/Typography";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function ModeWithTempCell(cell) {
  const minTemp = nullCheck(cell, "", "row", "original", "minTemp");
  const maxTemp = nullCheck(cell, "", "row", "original", "maxTemp");
  const eqType = nullCheck(cell, "", "row", "original", "equipmentTypeId");
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: active ? "white_opacity.100" : "black_solid.80"
        }}
      >
        {eqType !== "" ? `${cell.value} (${eqType})` : cell.value}
      </Typography>
      {(typeof (minTemp) === "number" || typeof (maxTemp) === "number") && (
        <Typography
          variant="body1"
          sx={{
            color: "primary.40",
            marginLeft: "6px"
          }}
        >
          {`${minTemp} / ${maxTemp}`}
        </Typography>
      )}
    </span>
  );
}